module.exports = __webpack_public_path__ + "static/media/dal.3eeb31e0.png";